import { preMatchApi } from '@features/event/api/eventApi';
import { IEvent } from '@features/event/api/eventApi.type';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EventState {
  selectedEvent?: IEvent
}

const initialState: EventState = {
    selectedEvent: undefined
}

export const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setSelectedEvent(state,action: PayloadAction<IEvent>) {
      state.selectedEvent = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(preMatchApi.endpoints.fetchEventById.matchFulfilled, (state, {payload}) => {
      if(payload) {
        state.selectedEvent = payload
      }
    });
  }
})

export const {setSelectedEvent} = eventSlice.actions
export default eventSlice.reducer